import { Pipe, PipeTransform } from "@angular/core";
import { FormValidationService } from "../../core/services/form-validation/form-validation.service";
import { AbstractControl } from "@angular/forms";
import { FieldKey } from "../../core/constants/form-validation-messages.constants";

@Pipe({
    name: "firstError",
    standalone: true,
    pure: false,
})
export class FirstErrorPipe implements PipeTransform {
    constructor(private readonly validation: FormValidationService) {}

    transform(control: AbstractControl | null, field: FieldKey, fallback = "Invalid value"): string | null {
        return this.validation.getFirstError(field, control, fallback);
    }
}
